import { createCullableNode } from '../utils/createCullableNode.mjs';
import { getInternalRouter } from '../utils/getInternalRouter.mjs';

/**
 * Redirect to the passed url.
 * @usage ./Redirect.usage.md
 */
const Redirect = (props, _children, utils) => {
    if (props.url == null)
        return null;
    const router = getInternalRouter();
    return createCullableNode(router.action(() => {
        router.replace(props.url);
    }), utils);
};

export { Redirect };
